/** @file INFO warning when no skin maps a slot's setup placeholder (legal, but probably a typo). */
import type { Doc, Id } from '@pose2d/format/types';
import type { CommandContext } from '../commandContext';

/** Appends INFO `{ placeholder }` at `path` unless some skin maps `placeholder` on slot `slotId`. */
export function warnUnmappedPlaceholder(doc: Doc, slotId: Id, placeholder: string, ctx: CommandContext, path: string): void {
  const mapped = Object.values(doc.skins).some((skin) => skin.entries.some((entry) => entry.slot === slotId && entry.placeholder === placeholder));
  if (mapped) return;
  const slotName = doc.slots[slotId]?.name ?? slotId;
  ctx.warnings.push({ code: 'INFO', message: `no skin maps placeholder "${placeholder}" on slot ${slotName} yet (map one with skin.setEntry)`, params: { placeholder }, path });
}
